<template src="./Payment.html" />


<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },

    },
    created() {
        this.$store.dispatch("lookups/getLookups");
        this.$store.dispatch("lookups/getPaymentAccounts");

    },
    computed: {
        paymentTypes() {
            return this.$store.state.lookups.paymentAccounts;
        },
    },
    data() {
        return {
            vm: {
                amount: null,
                remark: null,
                paymentTypeId: null,
                referenceNo: null,

            },

            hasReference: false,

        };
    },
    methods: {
        changePaymentTypes() {
            this.hasReference = false;
            let paymentAccount = this.paymentTypes.find((x) => {
                if (x.value == this.vm.paymentTypeId) return x
            })
            this.hasReference = paymentAccount.hasReference;
        },
        confirm() {
            var id = this.item.patientsPayment.id;
            let vm = {
                amount: this.item.servicePrice == null ? 0 : this.item.servicePrice,
                paymentTypeId: this.vm.paymentTypeId,
                referenceNo: this.vm.referenceNo,
                remark: this.vm.remark,
            }
            this.$store
                .dispatch("bookPatients/addPayment", { id: id, payload: vm })
                .then((res) => {
                    if (res.statusCode == 1) {

                        const routeData = this.$router.resolve(
                            `/receipt/${id}`
                        );
                        window.open(routeData.href, "_blank");
                        this.$emit("back");
                    }
                })
                .catch(() => { });
        },
    },
};
</script>